'use client'

import { AlertCircleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Alert, AlertDescription, AlertTitle } from '../ui/alert'

const GenericErrorAlert = () => {
  const { t } = useTranslation()

  return (
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertTitle>{t('genericError.title')}</AlertTitle>
      <AlertDescription>
        <p>{t('genericError.description')}</p>
      </AlertDescription>
    </Alert>
  )
}

export default GenericErrorAlert
